export const applyMaskedInput = (inputElement, config = {}) => {
    var _a;
    inputElement.setAttribute("autocomplete", "off");
    let originalValue = "";
    const character = (_a = config === null || config === void 0 ? void 0 : config.character) !== null && _a !== void 0 ? _a : "*";
    const getCaretPosition = (el) => {
        var _a;
        return (_a = el.selectionStart) !== null && _a !== void 0 ? _a : 0;
    };
    const getSelectionLength = (el) => {
        var _a, _b;
        return ((_a = el.selectionEnd) !== null && _a !== void 0 ? _a : 0) - ((_b = el.selectionStart) !== null && _b !== void 0 ? _b : 0);
    };
    const setCaretPosition = (el, position) => {
        el.setSelectionRange(position, position);
    };
    // Handle pasting text
    inputElement.addEventListener("paste", (e) => {
        var _a, _b;
        // Get the pasted text
        const pastedText = (_b = (_a = e.clipboardData) === null || _a === void 0 ? void 0 : _a.getData("text")) !== null && _b !== void 0 ? _b : "";
        const caretPosition = getCaretPosition(inputElement);
        // Prevent the default paste action
        e.preventDefault();
        // Insert the pasted text at the caret position, and adjust originalValue
        originalValue =
            originalValue.slice(0, caretPosition) +
                pastedText +
                originalValue.slice(caretPosition);
        // Update the masked value
        inputElement.value = character.repeat(originalValue.length);
        // Move the caret to the end of the pasted text
        setCaretPosition(inputElement, caretPosition + pastedText.length);
    });
    inputElement.addEventListener("beforeinput", (e) => {
        const caretPosition = getCaretPosition(inputElement);
        const selectionLength = getSelectionLength(inputElement);
        const inputType = e.inputType;
        const addedChar = e.data || "";
        if (inputType === "insertText") {
            if (selectionLength > 0) {
                // Replace selected text
                originalValue =
                    originalValue.slice(0, caretPosition) +
                        addedChar +
                        originalValue.slice(caretPosition + selectionLength);
            }
            else {
                // Insert new character
                originalValue =
                    originalValue.slice(0, caretPosition) +
                        addedChar +
                        originalValue.slice(caretPosition);
            }
        }
        else if (inputType === "deleteContentBackward") {
            if (selectionLength > 0) {
                // Delete selected text
                originalValue =
                    originalValue.slice(0, caretPosition) +
                        originalValue.slice(caretPosition + selectionLength);
            }
            else if (caretPosition > 0) {
                // Delete single character before caret
                originalValue =
                    originalValue.slice(0, caretPosition - 1) +
                        originalValue.slice(caretPosition);
            }
        }
        else if (inputType === "deleteContentForward") {
            if (selectionLength > 0) {
                // Delete selected text
                originalValue =
                    originalValue.slice(0, caretPosition) +
                        originalValue.slice(caretPosition + selectionLength);
            }
            else {
                // Delete single character after caret
                originalValue =
                    originalValue.slice(0, caretPosition) +
                        originalValue.slice(caretPosition + 1);
            }
        }
        else {
            return; // Ignore other input types
        }
        // Prevent default behavior since we handle value manually
        e.preventDefault();
        // Update masked value
        inputElement.value = character.repeat(originalValue.length);
        // Restore caret position
        const newCaretPosition = inputType === "insertText"
            ? caretPosition + 1
            : caretPosition - (selectionLength > 0 ? selectionLength : 1);
        setCaretPosition(inputElement, Math.max(0, newCaretPosition));
    });
    return {
        getOriginalValue: () => originalValue,
    };
};
